export default "__VITE_ASSET__CU5QU2I$__"